import styled from 'styled-components';

export const Details = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
